import { MessageCircle } from "lucide-react";
import { socials } from "../../lib/socials";

export default function FloatingWhatsApp() {
    return (
        <a
            href={socials.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="floating-whatsapp"
            className="floating-wa fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[60] group"
        >
            {/* Pulse ring */}
            <span
                aria-hidden
                className="absolute inset-0 rounded-full bg-[#E55B13] opacity-40 animate-ping"
            />
            <span className="relative flex items-center gap-2 pl-5 pr-5 md:pr-6 py-4 rounded-full bg-[#E55B13] text-black shadow-[0_20px_60px_-15px_rgba(229,91,19,0.6)] hover:bg-[#ff6a1e] transition-all duration-300 hover:scale-[1.04] active:scale-[0.96]">
                <MessageCircle size={18} strokeWidth={2} />
                <span className="hidden md:inline font-mono text-[11px] tracking-[0.22em] uppercase font-medium">
                    WhatsApp
                </span>
            </span>
        </a>
    );
}
